import { Form } from '@vivaldis/antd-ui'
import { ProcessEmployeeIdCardInput } from '@vivaldis/graphql'
import { FC } from 'react'
import { Step, useStep } from '../../provider/StepProvider'
import { Employee } from '../../types/Employee'
import { FormContent } from './components/FormContent'
import { FormProvider } from './provider/FormProvider'
import { ActionBar } from './components/ActionBar'

interface Props {
  employee: Employee
  onIDCardSubmit: (
    processEmployeeIdCardInput: ProcessEmployeeIdCardInput
  ) => Promise<Employee | undefined>
}

export const UploadIdCardStep: FC<Props> = ({ employee, onIDCardSubmit }) => {
  const { step } = useStep()

  if (step !== Step.UploadIdCardStep) {
    return null
  }

  return (
    <FormProvider employee={employee} onSubmit={onIDCardSubmit}>
      <Form autoComplete="off">
        <FormContent />
        <ActionBar />
      </Form>
    </FormProvider>
  )
}
